<desy-pill
  [classes]="classe"
  [ngClass]="{
    'deletable-pill': isDeletable,
    'clickable-pill': !isDeletable,
  }"
  (click)="!isDeletable && onRemove($event)">
  <span class="pill-content">{{ value }}</span>
  <button
    *ngIf="isDeletable"
    type="button"
    class="delete-button"
    (click)="onRemove($event)"
    aria-label="Eliminar">
    ×
  </button>
</desy-pill>
